module.exports = __webpack_public_path__ + "img/hk.e0cdc8af.svg";